import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step2 = ({ sra, setSra, setStep, storedUser }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.info)) {
      newErrors.info = "Vendor Information is required";
    } else if (data.info.length > 1000) {
      newErrors.info = "Vendor Information should be up to 1000 characters";
    }

    if (isEmpty(data.reference)) {
      newErrors.reference = "References is required";
    } else if (data.reference.length > 1000) {
      newErrors.reference = "References should be up to 1000 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-approval?draftSraId=${sra.draftVendorId}`,
        {
          info: sra.info,
          reference: sra.reference,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/dashboard/create-vendor-approval/draft/${sra.draftVendorId}`)
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>New Vendor Approval Form</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "40%" }}></span>
      </div>
      <div className="dashboard-container">
        <Box>
          <Typography className="form-title">Justification</Typography>
          <label htmlFor="info">
            Vendor Information <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.info && "input-error"}`}
            name="info"
            id="info"
            rows={4}
            value={sra && sra.info}
            onChange={handleChange}
            maxLength={1000}
          ></textarea>
          {errors.info && <p className="error">{errors.info}</p>}
          <label htmlFor="reference">
            Reference <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.reference && "input-error"}`}
            name="reference"
            id="reference"
            rows={4}
            value={sra && sra.reference}
            onChange={handleChange}
            maxLength={1000}
          ></textarea>
          {errors.reference && <p className="error">{errors.reference}</p>}
        </Box>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
